import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng';
import { ISupplierOperationalData } from '../../../../interfaces/supplier-schedule';

@Component({
  selector: 'app-supplier-classification',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  templateUrl: './supplier-classification.component.html',
  styleUrls: ['./supplier-classification.component.scss'],
})
export class SupplierClassificationComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  @Input() supplierOperationalData: ISupplierOperationalData;
}
